import INFTCollections from '../../models/INFTCollections'
import CryptoWaifusCard from '../../nftFormats/CryptoWaifus/Card/CryptoWaifusCard'
import CryptoWaifusDetail from '../../nftFormats/CryptoWaifus/Detail/CryptoWaifusDetail'
import CryptoWaifusActivtyDetail from '../../nftFormats/CryptoWaifus/Activity/CryptoWaifusActivtyDetail'
import CryptoWaifusLogo from '../../../../assets/nft-logo/CryptoWaifus.jpg'

export const CryptoWaifusData: INFTCollections = {
  id: 'CryptoWaifus',
  tokenAddress: '0x72dbaaf7d2296c7933ca2826eeeda9eec9e70880',
  name: 'Crypto Waifus',
  cardFormat: CryptoWaifusCard,
  detailFormat: CryptoWaifusDetail,
  activityFormat: CryptoWaifusActivtyDetail,
  category: 1,
  creatorAddress: '0x15358c1bfd36d32a8b687b1f7ebc581f40ac6c3b',
  logo: CryptoWaifusLogo,
  website: 'https://www.cryptowaifus.art/',
  twitter: 'AvaxWaifus'
}

export const CryptoWaifusCategoryData = {
  [CryptoWaifusData.tokenAddress.toLowerCase()]: CryptoWaifusData.category
}
